import React from 'react'
import { Dialog, DialogContent, DialogTitle } from '@mui/material'

const EditPopup = (props) =>{

  const {title, children, openPopupVar, setOpenPopupMet} = props;

  return(
    <Dialog open ={openPopupVar}>
     
      <DialogContent dividers>
        {children}
      </DialogContent>
    </Dialog>
  )

}

export default EditPopup;